module.exports = __webpack_public_path__ + "static/media/na.51096670.jpeg";